import { useCallback } from 'react';

import { YesOrNo } from '../../../YesOrNo';
import { usePastClaims } from '../../usePastClaims';

import type { PastClaimsProps } from '../../PastClaims';

export const ClaimsThresholdYesOrNo = <CoverageKey extends string>(props: PastClaimsProps<CoverageKey>) => {
  const { translations, onBack } = props;
  const [{ hasPastClaims }, { setHasPastClaims, openPastClaimForm, submit }] = usePastClaims();

  const handleConfirmYes = useCallback(async () => {
    openPastClaimForm();
    setHasPastClaims(true);
  }, []);

  const handleConfirmNo = useCallback(async () => {
    setHasPastClaims(false);
  }, []);

  return (
    <YesOrNo
      isSubmitting={props.isSubmitting ?? false}
      translations={{
        yes: translations.overviewYes,
        no: translations.overviewNo,
        submit: translations.overviewContinue,
        back: translations.previous,
      }}
      value={hasPastClaims}
      eventHandlers={{
        onSelectValue: (answer) => (answer ? handleConfirmYes() : handleConfirmNo()),
        onSubmit: (answer) => (answer ? handleConfirmYes() : submit([])),
        onBack: onBack,
      }}
    >
      {props.children}
    </YesOrNo>
  );
};
